import * as apiValues from '../constants/apiValues';
import * as carouselSlideActions from '../actions/carouselSlideActions';
import * as helpers from '../helpers';
import * as mHeaderActions from '../actions/mHeaderActions';
import * as pageHomeActions from '../actions/pageHomeActions';
import MListNav from './MListNav';
import PropTypes from 'prop-types';
import React from 'react';
import SuperLink from './SuperLink';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {SiteSearch} from './SiteSearch';
import {withRouter} from '../withRouterCompat';


class CarouselSlide extends React.Component{
  _suppressHeroSearchOverlay = false;
  _heroSearchPointerIntent = false;

  constructor(props){
    super(props);

    this.state = {
      searchQuery: '',
      searchBusy: false,
    };
    this.debouncedDoSearch = helpers.debounceEvent((query) => {
      Promise.resolve(this.props.actions.pageHome.doSearch(query))
        .then(() => {
          if(this.state.searchQuery === query){
            this.setState({searchBusy: false});
          }
        })
        .catch(() => {
          if(this.state.searchQuery === query){
            this.setState({searchBusy: false});
          }
        });
    }, 300);
  }
  componentDidMount(){
    //console.log(`CarouselSlide.componentDidMount()`, this.props);
    this.props.actions.carouselSlide.initCarouselSlide(this.props.cmsId);
  }
  componentWillUnmount(){
    this.debouncedDoSearch.cancel();
  }
  componentDidUpdate(prevProps){
    const prevSearchTab = helpers.getById(prevProps.mHeaderTab, 'search');
    const searchTab = helpers.getById(this.props.mHeaderTab, 'search');
    if(prevSearchTab && prevSearchTab.isOpen && searchTab && !searchTab.isOpen &&
       helpers.isScreenSmallerThan(helpers.screenSizes.lgMin)){
      this._suppressHeroSearchOverlay = true;
    }
  }


  carouselSearch__onClick = (e) => {
    e.preventDefault();
    this.openMobileSearchFromHero();
    return null;


    //this.props.actions.menuToggle(typeof isOpen != "undefined" ? isOpen : !this.props.mHeader.isOpen);
    //this.props.actions.toggleAllTabs(false);
    //this.props.actions.tabToggle('search', true);
  };
  input_onChange = event => {
    const value = event.target.value;
    const isSearchOpen = value.length > 0;
    if(Boolean(this.props.page?.isSearchOpen) !== isSearchOpen){
      this.props.actions.pageHome.toggleSearch(isSearchOpen);
    }
    this.setState({
      searchQuery: value,
      searchBusy: Boolean(value),
    });
    this.handleSearch(value);
  };
  search_onSubmit = () => {
    this.props.history.push(`/projects?Title_contains=${this.state.searchQuery}`);
  };
  searchClear_onClick = () => {
    this.setState({searchQuery: '', searchBusy: false});
    setTimeout(() => {
      this.props.actions.pageHome.toggleSearch(false);
    });
  };
  openMobileSearchFromHero = () => {
    this.props.actions.mHeader.setSearchReturnFocus('hero');
    this.props.actions.mHeader.menuToggle(false);
    this.props.actions.mHeader.tabToggle('search', true);
    this.props.actions.mHeader.expandedTab({
      expandedTabBarVisible: false,
      expandedTab: 'search',
    });
    window.setTimeout(() => {
      document.getElementById('search-main')?.focus();
    }, 0);
  };
  siteSearch_onBlur = () => {
    this.props.actions.pageHome.toggleSearch(false);
  };
  siteSearch_onPointerDown = () => {
    this._heroSearchPointerIntent = true;
  };
  siteSearch_onFocus = () => {
    if(this._suppressHeroSearchOverlay){
      this._suppressHeroSearchOverlay = false;
      return;
    }
    if(helpers.isScreenSmallerThan(helpers.screenSizes.lgMin)){
      if(!this._heroSearchPointerIntent){
        return;
      }
      this._heroSearchPointerIntent = false;
      this.openMobileSearchFromHero();
      return;
    }
    this.props.actions.pageHome.toggleSearch(true);
  };


  handleSearch = query => {
    if(!query){
      this.debouncedDoSearch.cancel();
      this.setState({searchBusy: false});
      this.props.actions.pageHome.doSearch('');
      return;
    }
    this.debouncedDoSearch(query);
  };


  isHeroSearchSlide = () => {
    const slide = this.props.carouselSlide;
    if (!slide) return false;
    const name = slide.cmsName || slide.CMSName;
    return name === apiValues.CAROUSEL_SLIDE_HERO_SEARCH;
  };
  renderCarouselSearch = () => {
    if (!this.isHeroSearchSlide()) return null;
    return (
      <div className="carouselslide__search">
        <div id="hero-search-label" className="carouselslide__search-description">Search Our Projects</div>
        <div className="carouselslide__search-container">
          {/* <SiteSearch className="site-search--carousel-slide"/> */}
          <SiteSearch className={`site-search--carousel-slide`}
                      ariaLabelledBy="hero-search-label"
                      inputID="hero-search-input"
                      isOpen={this.props.page.isSearchOpen}
                      onBlur={this.siteSearch_onBlur}
                      onClearClick={this.searchClear_onClick}
                      onFocus={this.siteSearch_onFocus}
                      onPointerDown={this.siteSearch_onPointerDown}
                      onInputChange={this.input_onChange}
                      onSubmit={this.search_onSubmit}
                      isLoading={this.state.searchBusy}
                      inputPlaceholder="Try Figueroa, Venice, Avalon or a street near you.">
            <div className="row">
              {this.renderFeaturedProjects()}
              {this.renderSuggestedProjects()}
            </div>
          </SiteSearch>
          {/* <div className="carouselslide__search-cover" onClick={(e) => {
            this.carouselSearch__onClick(e);
          }}></div> */}
        </div>
      </div>
    );
  };
  renderDescription = () => {
    if (!(this.props.carouselSlide && this.props.carouselSlide.description)) return null;

    // Always h2 in React; MCarousel.syncCarouselHeadingLevels promotes the active hero to h1
    // so infiniteLoop clones never leave duplicate h1s in the DOM.
    return (
      <h2 className="carouselslide__description">
        {this.props.carouselSlide.description}
      </h2>
    );
  };
  renderFeaturedProjects = () => {
    if(this.props.page.suggestedProjects) return null;

    return (
      <div className="col-12">
        <MListNav cmsName={apiValues.NAV_FEATURED_PROJECTS} className="m-listnav--page-search-results"/>
      </div>
    );
  };
  renderSuggestedProjects = () => {
    if(!this.props.page.suggestedProjects) return null;

    let mListNav = {
      title: 'Suggested Projects',
      navigationLinks: this.props.page.suggestedProjects.slice(0, 4).map(project => {
        return {
          key: project.id,
          title: project.title,
          url: `/projects/${project.slug ? project.slug : ''}`,
        };
      }),
      highlight: this.state.searchQuery,
    };

    if(this.props.page.suggestedProjects.length === 0) return (
      <div className="col-12">
        <div className="no-search-results">{`Sorry this search doesn't have any results.`}</div>
        {/* <MListNav mListNav={mListNav} className="m-listnav--page-search-results"/> */}
        <div className="no-results-suggestion">
          Search Suggestions
          <ul>
            <li>
              Check spelling
            </li>
            <li>
              Try more general words
            </li>
            <li>
              Remove some search filters
            </li>
            <li>
              <a href="/get-involved" target="_blank">Contact us</a> {`if you still can't find what you are looking for`}
            </li>
          </ul>
        </div>
        {/* <SuperLink to="projects" className="m-projectlistmap__results-link">View all projects for &quot;{this.state.searchQuery}&quot;</SuperLink> */}
      </div>
    );
    else return (
      <div className="col-12">
        <MListNav mListNav={mListNav} className="m-listnav--page-search-results"/>
        <SuperLink to={`${this.state.searchQuery && this.state.searchQuery !== '' ? '/projects?Title_contains=' + this.state.searchQuery : '/projects'}`} className="m-projectlistmap__results-link">View all projects for <q>{this.state.searchQuery}</q></SuperLink>
      </div>
    );
  };
  render(){
    // console.log(`CarouselSlide render`, this.props.page);
    if(!this.props.page ||
       !this.props.carouselSlide) return null;

    return (
      <div className="carouselslide">
        <div className="carouselslide__content">
          {this.renderDescription()}
          {this.renderCarouselSearch()}
        </div>
      </div>
    );
  }
}


export default withRouter(connect(
  (state, ownProps) => ({
    carouselSlide: helpers.getById(state.carouselSlide, ownProps.cmsId),
    mHeader: state.mHeader,
    mHeaderTab: state.mHeaderTab,
    page: state.pageHome,
  }),
  (dispatch) => ({
    actions: {
      carouselSlide: bindActionCreators(carouselSlideActions, dispatch),
      mHeader: bindActionCreators(mHeaderActions, dispatch),
      pageHome: bindActionCreators(pageHomeActions, dispatch),
    },
  }),
)(CarouselSlide));


CarouselSlide.propTypes = {
  actions: PropTypes.object.isRequired,
  carouselSlide: PropTypes.object,
  className: PropTypes.string,
  cmsId: PropTypes.string.isRequired,
  history: PropTypes.object,
  mHeaderTab: PropTypes.array,
  page: PropTypes.object,
};
